import { render, staticRenderFns } from "./WhitePaper.vue?vue&type=template&id=a4642c10&"
import script from "./WhitePaper.vue?vue&type=script&lang=js&"
export * from "./WhitePaper.vue?vue&type=script&lang=js&"
import style0 from "./WhitePaper.vue?vue&type=style&index=0&id=a4642c10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports